import type { CSSProperties, ReactNode } from 'react'

// The world's one panel shape: a rule with notched (chamfered) pixel corners, as on every
// banner, status box, card and pill in the approved comp. Two chamfered layers: the outer
// in the rule's ink, the inner in the fill, inset by the rule's width.
const chamfer = (c: number) =>
	`polygon(${c}px 0, calc(100% - ${c}px) 0, 100% ${c}px, 100% calc(100% - ${c}px), calc(100% - ${c}px) 100%, ${c}px 100%, 0 calc(100% - ${c}px), 0 ${c}px)`

type Props = {
	ink: string
	fill?: string
	cut?: number
	rule?: number
	glow?: boolean
	className?: string
	contentClassName?: string
	style?: CSSProperties
	children?: ReactNode
}

export function PixelFrame({
	ink,
	fill = 'var(--panel)',
	cut = 8,
	rule = 2,
	glow = true,
	className = '',
	contentClassName = 'items-center justify-center',
	style,
	children,
}: Props) {
	return (
		<div
			className={/\b(absolute|fixed)\b/.test(className) ? className : `relative ${className}`}
			style={{ ...style, filter: glow ? `drop-shadow(0 0 5px ${ink}66)` : undefined }}
		>
			<div className="absolute inset-0" style={{ background: ink, clipPath: chamfer(cut) }} />
			<div
				className="absolute"
				style={{ inset: rule, background: fill, clipPath: chamfer(Math.max(1, cut - rule / 2)) }}
			/>
			<div className={`relative flex h-full w-full flex-col ${contentClassName}`}>{children}</div>
		</div>
	)
}
